import React from 'react'

import {
  H1,
} from '../styles'

const OverPrompt = ({players, player}) => {
  if (player && player.alive) {
    return <div>
      <H1>You win!!!</H1>
      <p>You won the whole game!</p>
      <p>By the way, your poison word was "{player.poisonWord}"</p>
    </div>
  } else {
    let winner = players.find(p => p.alive)
    return <div>
      <H1>Game Over</H1>
      <p>{winner.name} won!</p>
    </div>
  }
}

export default OverPrompt



// WEBPACK FOOTER //
// ./src/views/game/3_OverPrompt.jsx